type CustomGestureHandler = (downX: number, downY: number) => boolean

const handlers = new Set<CustomGestureHandler>()

export const isPointInElement = (x: number, y: number, el: Element | null | undefined) => {
  if (!el) return false
  const rect = el.getBoundingClientRect()
  return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom
}

export const isPointInElementWithPadding = (
  x: number,
  y: number,
  el: Element | null | undefined,
  padding: { top?: number; right?: number; bottom?: number; left?: number } = {}
) => {
  if (!el) return false
  const rect = el.getBoundingClientRect()
  const { top = 0, right = 0, bottom = 0, left = 0 } = padding
  return (
    x >= rect.left - left &&
    x <= rect.right + right &&
    y >= rect.top - top &&
    y <= rect.bottom + bottom
  )
}

export const toGesturePoint = (downX: number, downY: number) => {
  const dpr = window.devicePixelRatio || 1
  return { x: downX / dpr, y: downY / dpr }
}

/** 仅在横向滚动容器内居中子元素，避免 scrollIntoView 带动外层纵向滚动 */
export const scrollHorizontalChildToCenter = (
  container: HTMLElement | null | undefined,
  el: HTMLElement | null | undefined,
  behavior: ScrollBehavior = 'smooth'
) => {
  if (!container || !el) return
  const containerRect = container.getBoundingClientRect()
  const elRect = el.getBoundingClientRect()
  const targetScrollLeft =
    container.scrollLeft + (elRect.left - containerRect.left) - (containerRect.width - elRect.width) / 2
  const maxScrollLeft = Math.max(0, container.scrollWidth - container.clientWidth)
  container.scrollTo({
    left: Math.max(0, Math.min(targetScrollLeft, maxScrollLeft)),
    behavior,
  })
}

const dispatchCustomGesture: CustomGestureHandler = (downX, downY) => {
  for (const handler of handlers) {
    if (handler(downX, downY)) return true
  }
  return false
}

const syncGlobalCustomGesture = () => {
  if (handlers.size > 0) {
    window.customGesture = dispatchCustomGesture
  } else if (window.customGesture === dispatchCustomGesture) {
    window.customGesture = undefined
  }
}

export const registerCustomGestureHandler = (handler: CustomGestureHandler) => {
  handlers.add(handler)
  syncGlobalCustomGesture()
}

export const unregisterCustomGestureHandler = (handler: CustomGestureHandler) => {
  handlers.delete(handler)
  syncGlobalCustomGesture()
}
